<template>
  <div
    @click="toggleNavBar"
    class="nav-switch-container"
    :class="showNavBar ? '' : 'nav-close'"
  >
    <span class="nav-switch-label" :class="showNavBar ? 'nav-active' : ''"
      >场景选择</span
    >
  </div>

  <div class="nav-container" :class="!showNavBar ? 'nav-container-close' : ''">
    <div class="nav-bar-top">
      <div
        class="nav-label-def"
        @click="changeActiveTab(tabItemLv1, index1, 'LV1')"
        :class="activeLv1fullId == tabItemLv1.id ? 'nav-label-active' : ''"
        v-for="(tabItemLv1, index1) in navbarLv1List"
        :key="tabItemLv1.id"
      >
        <span class="nav-label-def-map-left" v-show="tabItemLv1.isMap && tabItemLv1.isLeft" @click.stop="showMap(tabItemLv1.mapTitle,tabItemLv1.mapImg)">架构图</span>
        <span>{{ tabItemLv1.title }}</span> 
        <span class="nav-label-def-map" v-show="tabItemLv1.isMap && !tabItemLv1.isLeft" @click.stop="showMap(tabItemLv1.mapTitle,tabItemLv1.mapImg)">架构图</span>
      </div>
    </div>
    <div class="nav-bar-second">
      <div
        class="nav-label-def-lv2"
        @click="changeActiveTab(tabItemLv2, index2, 'LV2')"
        :class="activeLv2fullId == tabItemLv2.id ? 'nav-label-active-lv2' : ''"
        v-for="(tabItemLv2, index2) in navbarLv2List"
        :key="tabItemLv2.id"
      >
        <span class="nav-label-def-lv2-map-left" v-show="tabItemLv2.isMap && tabItemLv2.isLeft" @click.stop="showMap(tabItemLv2.mapTitle,tabItemLv2.mapImg)">架构图</span>
        <span class="nav-label-def-lv2-title">{{ tabItemLv2.title }}</span> 
        <span class="nav-label-def-lv2-map" v-show="tabItemLv2.isMap && !tabItemLv2.isLeft" @click.stop="showMap(tabItemLv2.mapTitle,tabItemLv2.mapImg)">架构图</span>
      </div>
    </div>
    <div class="nav-bar-third" ref="navBarThird">
      <span
        class="nav-label-def-lv3"
        :class="activeLv3fullId == tabItemLv3.id ? 'nav-label-active-lv3' : ''"
        @click="changeActiveTab(tabItemLv3, index3, 'LV3')"
        v-for="(tabItemLv3, index3) in navbarLv3List"
        :key="tabItemLv3.id"
      >
        {{ tabItemLv3.title }}</span
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "NavBarBottom",
  props: {
    showNavBar: Boolean,
    activePictureId: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      navbarData:[],
      // 添加拖拽状态变量t
      isDragging: false,
      startX: 0,
      scrollLeft: 0,
      //单个级别的数字
      activeIdLv1: 0,
      activeIdLv2: 0,
      activeIdLv3: 0,
      tempPictureId: ""
    };
  },
  computed: {
    navbarLv1List() {
      return this.navbarData.filter((item) => {
        return item.visible == true;
      });
    },
    //单个字符型数字
    activeTabLv1Id() {
      return this.activeIdLv1 || "1";
    },
    //用于判断高亮  值为id完整格式xxx-xxx-xxx
    activeLv1fullId() {
      return this.activeTabLv1Id;
    },
    //单个字符型数字
    activeTabLv2Id() {
      //console.log('activeIdLv2',this.activeIdLv2)
      return this.activeIdLv2 || "1";
    },
    //用于判断高亮  值为id完整格式xxx-xxx-xxx
    activeLv2fullId() {
      return this.activeLv1fullId + "-" + this.activeTabLv2Id;
    },
    //单个字符型数字
    activeTabLv3Id() {
      return this.activeIdLv3 || "1";
    },
    //用于判断高亮  值为id完整格式xxx-xxx-xxx
    activeLv3fullId() {
      return this.activePictureId;
    },
    //当前选择的一级分类
    activeSenceLv1() {
      return (
        this.navbarLv1List.find((nav) => {
          return nav.id.split("-")[0] == this.activeTabLv1Id;
        }) || []
      );
    },
    //当前一级场景下的二级场景列表
    navbarLv2List() {
      return this.activeSenceLv1.children ? this.activeSenceLv1.children.filter((item) => {
        return item.visible == true;
      }) : [];
    },
    //当前选择的二级分类
    activeSenceLv2() {
      return (
        this.navbarLv2List.find((nav) => {
          return nav.id.split("-")[1] == this.activeTabLv2Id;
        }) || []
      );
    },
    //当前二级场景下的三级场景列表
    navbarLv3List() {
      if (Object.keys(this.activeSenceLv2).length > 0) {
        return this.activeSenceLv2.children.filter((item) => {
          return item.visible == true;
        });
      } else {
        return [];
      }
    },
    //当前选择的三级分类
    activeSenceLv3() {
      return (
        this.navbarLv3List.find((nav) => {
          return nav.id.split("-")[2] == this.activeTabLv3Id;
        }) || []
      );
    },
  },
  methods: {
    changeActiveTab(tabItem, index, mark) {
      this.$emit("changeNavTab", {
        tabItem,
        mark,
      });
      this.$nextTick(() => {
        //console.log('changeActiveTab',tabItem.id,index,mark)
        //console.log('tempPictureId',this.tempPictureId,this.activePictureId)
        if(this.tempPictureId != this.activePictureId){
          this.tempPictureId = this.activePictureId;
          if (mark == "LV1") {
            if (this.activeIdLv1 != tabItem.id.split("-")[0]) {
              this.activeIdLv1 = tabItem.id.split("-")[0];
              this.activeIdLv2 = "1";
              this.activeIdLv3 = "0";
            }
          } else if (mark == "LV2") {
            if (this.activeIdLv2 != tabItem.id.split("-")[1]) {
              this.activeIdLv1 == tabItem.id.split("-")[0];
              this.activeIdLv2 = tabItem.id.split("-")[1];
              this.activeIdLv3 = "0";
            }
          } else if (mark == "LV3") {
            this.activeIdLv1 == tabItem.id.split("-")[0];
            this.activeIdLv2 == tabItem.id.split("-")[1];
            this.activeIdLv3 = tabItem.id.split("-")[2];
          }
          //console.log('level',this.activeIdLv1,this.activeIdLv2,this.activeIdLv3)
        }
      });
    },
    initActiveIndex() {
      let ids = this.activePictureId.split("-");
      this.activeIdLv1 = ids[0];
      this.activeIdLv2 = ids[1];
      this.activeIdLv3 = ids[2];
      this.tempPictureId = this.activePictureId;
    },
    toggleNavBar() {
      this.$emit("update:showNavBar", !this.showNavBar);
    },
    showMap(title,img) {
      this.$emit('showMap',title,img);
    },
    startDrag(e) {
      if (e.button !== 0) return; // 确保是鼠标左键
      this.isDragging = true;
      this.startX = e.pageX;
      this.scrollLeft = this.$refs.navBarThird.scrollLeft;
      e.preventDefault();
    },
    onDrag(e) {
      if (!this.isDragging) return;
      const x = e.pageX - this.startX;
      this.$refs.navBarThird.scrollLeft = this.scrollLeft - x;
      e.preventDefault();
    },
    stopDrag() {
      this.isDragging = false;
    },
    changeActiveIndexLv1(index) {
      this.activeIndexLv1 = index;
      this.activeIndexLv2 = 0;
      this.activeIndexLv3 = 0;
    },
    changeActiveIndexLv2(index) {
      this.activeIndexLv2 = index;
      this.activeIndexLv3 = 0;
    },
    changeActiveIndexLv3(index) {
      this.activeIndexLv3 = index;
    },
  },
  mounted() {
    fetch('https://media.tp-link.com.cn/webresource/act/vr/nav.json?'+Date.now(), {
        mode: 'cors'
    })
    .then(response => response.json())
    .then(data => {
      this.navbarData = data;
      this.initActiveIndex();
    })
    .catch(error => console.error('Error:', error));
    
  },
};
</script>
<style scoped lang="scss">
@use "sass:math";

@function px2vw($px) {
  @return math.div(100px * $px, 1920px) * 1vw;
}

@function px2vh($px) {
  @return math.div(100px * $px, 1080px) * 1vh;
}

.nav-switch-container {
  position: fixed;
  bottom: 0;
  height: px2vw(32);
  width: px2vw(80);
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;

  .nav-switch-label {
    font-family: SourceHanSansCN-Bold;
    font-size: px2vw(12);
    color: #ffffff;
    letter-spacing: px2vw(0.24);
    line-height: px2vw(18);
    font-weight: 400;
  }

  .nav-active {
    color: #ffda2d;
  }

  &.nav-close {
    background: rgba(0, 0, 0, 0.3);
    color: #ffffff;
  }
}
.nav-container {
  position: fixed;
  bottom: px2vw(40);
  width: 100%;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateY(0);
  opacity: 1;

  &.nav-container-close {
    // transform: translateY(calc(100% + px2vw(40)));
    opacity: 0;
    pointer-events: none;
  }

  .nav-label-def {
    font-family: SourceHanSansCN-Bold;
    font-size: px2vw(14);
    color: #ffffff;
    letter-spacing: px2vw(0.28);
    height: px2vw(20);
    font-weight: 500;
    margin-left: px2vw(15);
    margin-right: px2vw(15);
    display: flex;
    align-items: center;
    cursor: pointer;

    &.nav-label-active {
      color: #ffda2d;
    }

    .nav-label-def-map{
      margin-left: px2vw(6);
      padding:0 px2vw(5) 0 px2vw(6);
      background: rgba(224,224,224,0.5);
      color: #fff;
      font-family: SourceHanSansCN-Medium;
      font-size: px2vw(10);
      height: px2vw(16);
      display: inline-block;
      line-height: px2vw(16);
      margin-top: 0.1vw;
      &:hover{
        background: #2787FE;
      }
    }
    .nav-label-def-map-left{
      margin-right: px2vw(8);
      padding:0 px2vw(5) 0 px2vw(6);
      background: rgba(224,224,224,0.5);
      color: #fff;
      font-family: SourceHanSansCN-Medium;
      font-size: px2vw(10);
      height: px2vw(16);
      display: inline-block;
      line-height: px2vw(16);
      margin-top: 0.1vw;
      &:hover{
        background: #2787FE;
      }
    }
  }

  .nav-bar-top {
    padding: 0.416667vw 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
  }

  .nav-bar-second {
    margin-top: px2vw(6);
    margin-bottom: px2vw(6);
    padding: px2vw(7) 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);
    .nav-label-def-lv2 {
      font-family: SourceHanSansCN-Bold;
      font-size: px2vw(12);
      color: #ffffff;
      letter-spacing: px2vw(0.24);
      line-height: px2vw(18);
      margin-left: px2vw(15);
      margin-right: px2vw(15);
      cursor: pointer;
      &.nav-label-active-lv2 {
        color: #ffda2d;
      }
      .nav-label-def-lv2-map{
        margin-left: px2vw(6);
        padding:0 px2vw(5) 0 px2vw(6);
        background: rgba(224,224,224,0.5);
        color: #fff;
        font-family: SourceHanSansCN-Medium;
        font-size: px2vw(10);
        height: px2vw(16);
        display: inline-block;
        line-height: px2vw(16);
        &:hover{
          background: #2787FE;
        }
      }
      .nav-label-def-lv2-map-left{
        margin-right: px2vw(8);
        margin-bottom: px2vw(2);
        padding:0 px2vw(5) 0 px2vw(6);
        background: rgba(224,224,224,0.5);
        color: #fff;
        font-family: SourceHanSansCN-Medium;
        font-size: px2vw(10);
        height: px2vw(16);
        display: inline-block;
        line-height: px2vw(16);
        &:hover{
          background: #2787FE;
        }
      }
    }
  }

  .nav-bar-third {
    display: block;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.5);
    overflow-x: auto;
    white-space: nowrap;
    display: flex;
    justify-content: center;
    align-items: center;

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      background: transparent;
    }

    .nav-label-def-lv3 {
      padding-top: px2vw(7);
      padding-bottom: px2vw(7);
      font-family: SourceHanSansCN-Bold;
      font-size: px2vw(12);
      color: #ffffff;
      letter-spacing: px2vw(0.24);
      line-height: px2vw(18);
      height: px2vw(18);
      margin-left: px2vw(10);
      margin-right: px2vw(10);
      white-space: nowrap;
      cursor: pointer;
      display: inline-block;

      &.nav-label-active-lv3 {
        color: #ffda2d;
      }
    }
  }
}
</style>
